import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import logo from './providers/printeers_logo.png';

const Img = styled.img`
    width: 100%;
`;

const LogoContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 180px;
    height: 180px;
`;
export const InvitionImage: FunctionComponent<{}> = () => <Img src={`${logo}`}></Img>;
const InvitionLogo: FunctionComponent<{}> = () => (
    <LogoContainer>
        <InvitionImage></InvitionImage>
    </LogoContainer>
);

export default InvitionLogo;
